import { Injectable, signal } from '@angular/core';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})
export class GlobalToasterService {
    private timmer;
    private toaster = signal({
        show: false,
        message: '',
    });

    constructor(private apiService: ApiService) {
        this.handleFetchMaintenance();
        this.scheduleApiCalls();
    }

    public getToaster() {
        return this.toaster();
    }

    public setToaster(data) {
        this.toaster.set(data);
        if (!data.show) this.scheduleApiCalls();
    }

    private fetchMaintenance(): Observable<any> {
        return this.apiService.get(`${API_ENDPOINTS.MAINTENANCE}`);
    }

    private handleFetchMaintenance(): void {
        this.fetchMaintenance().subscribe({
            next: (response) => {
                if (Object.entries(response).length) {
                    clearInterval(this.timmer);
                    this.toaster.set({
                        show: true,
                        message: response?.message?.replace(/\n/g, '<br>'),
                    });
                }
            },
        });
    }

    private scheduleApiCalls(): void {
        const delay = environment.MAINTANCE_CHECK_DELAY;
        clearInterval(this.timmer);
        this.timmer = setInterval(() => {
            this.handleFetchMaintenance();
        }, delay);
    }
}
